module.exports = __webpack_public_path__ + "pc/img/award2022_01.162d9aff.webp";